import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RideDetail } from 'src/app/shared/interfaces/ride-data.interface';

@Component({
    selector: 'app-telematics-section-details',
    templateUrl: './telematics-section-details.component.html',
    styleUrls: ['./telematics-section-details.component.scss'],
    imports: [DatePipe, CommonModule],
    encapsulation: ViewEncapsulation.None
})
export class TelematicsSectionDetailsComponent {
  constructor(public datepipe: DatePipe) {}

  @Input() rideDetailsResult: RideDetail = new RideDetail();

  public getRideEventValue(eventTypeId: number) {
    let value: number = 100;
    let data = this.rideDetailsResult?.rideEvents.find(
      a => a.eventTypeId == eventTypeId,
    );
    if (data) {
      value = data.percentage;
    }
    return value;
  }

  public splitTime(numberOfHours?: number): string {
    let days: number = 0;
    let hourss: number = 0;
    let mins: number = 0;
    if (numberOfHours) {
      if (Math.sign(numberOfHours) === -1) {
        let absTotal = Math.abs(numberOfHours);
        mins = absTotal % 60;
        let hours = Math.floor(absTotal / 60);
        days = Math.floor(hours / 24);
        hourss = hours % 24;
      } else {
        mins = numberOfHours % 60;
        let hours = Math.floor(numberOfHours / 60);
        days = Math.floor(hours / 24);
        hourss = hours % 24;
      }
    }
    let daysValue = days == 0 ? '' : `${days} d`;
    let hoursValue = hourss == 0 ? '' : `${hourss} h`;
    let minutesValue = mins == 0 ? '' : `${mins} min`;

    return `${daysValue} ${hoursValue} ${minutesValue}`;
  }
}
